<template>
	<div
		:class="[
			'payment-summary-line',
			{
				'payment-line-border-top': hasBorder,
			},
		]"
	>
		<div class="payment-summary-line-left">
			<slot name="line-left" />
		</div>

		<div class="payment-summary-line-right">
			<slot name="line-right" />
		</div>
	</div>
</template>

<script setup lang="ts">
const { hasBorder } = defineProps({
	hasBorder: {
		type: Boolean,
		default: false,
	},
});
</script>

<style scoped lang="scss">
.payment-summary-line {
	padding: $spacing-s 0;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;

	.payment-summary-line-right {
		text-align: right;
	}
}

.payment-line-border-top {
	border-top: 2px solid $color-neutrals-100-tint;
}
</style>
